import httpRequest from './httpRequest';
import { getBaseRequestConfig, LOCAL_BASE_PATH } from './baseRequestConfig';

export function fetchFundraiserComments(
  accessToken,
  fundraiserSlug,
  page = 1,
  pageSize = 3
) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${LOCAL_BASE_PATH}/comment/fundraiser/${fundraiserSlug}?page=${page}&pageSize=${pageSize}`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'GET',
  });

  return httpRequest(requestConfig);
}

export function postFundraiserComment(
  accessToken,
  fundraiserId,
  fundraiserComment,
  recaptchaToken
) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${LOCAL_BASE_PATH}/comment/fundraiser/${fundraiserId}`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'POST',
    data: Object.assign({}, fundraiserComment, {
      googleReCaptchaToken: recaptchaToken,
    }),
  });

  return httpRequest(requestConfig);
}

export function deleteFundraiserComment(accessToken, fundraiserId, commentId) {
  const baseRequestConfig = getBaseRequestConfig(accessToken);
  const url = `${LOCAL_BASE_PATH}/comment/fundraiser/${fundraiserId}/${commentId}`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'DELETE',
  });

  return httpRequest(requestConfig);
}

export function reportFundraiserComment(fundraiserId, commentId) {
  const baseRequestConfig = getBaseRequestConfig();
  const url = `${LOCAL_BASE_PATH}/comment/fundraiser/${fundraiserId}/report/${commentId}`;

  const requestConfig = Object.assign({}, baseRequestConfig, {
    url: url,
    method: 'PUT',
  });

  return httpRequest(requestConfig);
}
